import React from 'react';
import { ImageProps } from '@components/image';
import Wrapper from '@components/wrapper.styled';
import getBlogType from '@helpers/get-blog-type';
// import TagList from '@components/posts-list/tag-list/tag-list';
import {
  EmptyState,
  PostsGrid,
  StyledLink,
  StyledTextLink,
  StyledImage,
  // Meta,
  PostInfo,
  NoImage,
} from './posts-list.shared.styled';
import {
  PostContent,
  StyledTitle,
  ImageContainer,
  LinkedTitle,
  PostWrapper,
} from './relative-posts-list.styled';

export interface PostPreviewGraphqlType {
  type: 'blog_post' | 'guides_post' | 'case_studies_post';
  uid: string;
  prismicId: string;
  first_publication_date: string;
  tags: string[];
  data: {
    title: {
      text: string;
    };
    content: {
      text: string;
    };
    featured_image: ImageProps;
  };
}

const PostPreview = ({
  node,
  postsType,
}: {
  node: PostPreviewGraphqlType;
  postsType: string;
}): JSX.Element => {
  const imageUrl = node.data.featured_image?.url;
  const isImageless = !imageUrl?.trim();

  if (!node.data.title.text) {
    return <></>;
  }

  return (
    <PostWrapper>
      <ImageContainer postsType={postsType}>
        {imageUrl ? (
          <StyledLink to={`${getBlogType(postsType)}/${node.uid}`}>
            <StyledImage url={imageUrl} alt={node.data.featured_image.alt} />
          </StyledLink>
        ) : (
          <NoImage />
        )}
      </ImageContainer>
      <PostContent isImageless={isImageless}>
        <PostInfo>
          <StyledTextLink to={`${getBlogType(postsType)}/${node.uid}`}>
            <LinkedTitle
              type="title"
              tag="h3"
              fontSize="heading5"
              fontColor="secondary"
              stringText={node.data.title.text}
            />
          </StyledTextLink>
        </PostInfo>
        {/* <Meta>
          <TagList tags={node.tags} blogUrl={postsType === 'guides_post' ? '/guides' : '/blog'} />
        </Meta> */}
      </PostContent>
    </PostWrapper>
  );
};

export interface PostsListProps {
  edges: {
    node: PostPreviewGraphqlType;
  }[];
  title?: string;
  postsType: string;
}

const PostsList = ({ edges = [], title, postsType }: PostsListProps): JSX.Element => {
  return (
    <>
      {title && (
        <StyledTitle fontSize="heading4" type="title" stringText={title} fontColor="dark" />
      )}
      <Wrapper>
        {edges.length > 0 ? (
          <PostsGrid>
            {edges.map(({ node }) => (
              <PostPreview node={node} postsType={postsType} key={node.uid} />
            ))}
          </PostsGrid>
        ) : (
          <EmptyState>No posts found.</EmptyState>
        )}
      </Wrapper>
    </>
  );
};

export default PostsList;
